import React from 'react';
import { cn } from '@shared/ui/utils/tailwind';

export type TitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  component?: React.ElementType;
  className?: string;
};

export const Title: React.FC<TitleProps> = ({
  order = 1,
  size,
  component,
  className,
  children,
  ...props
}) => {
  const HeadingTag = (component || `h${order}`) as React.ElementType;

  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
  };

  const orderClasses = {
    1: 'text-[var(--text-h1)] font-bold',
    2: 'text-[var(--text-h2)] font-bold',
    3: 'text-[var(--text-h3)] font-semibold',
    4: 'text-[var(--text-h4)] font-semibold',
    5: 'text-[var(--text-h5)] font-medium',
    6: 'text-[var(--text-h6)] font-medium',
  };

  return (
    <HeadingTag
      className={cn(
        'text-[var(--text-primary)]',
        size ? sizeClasses[size] : orderClasses[order],
        className
      )}
      {...props}
    >
      {children}
    </HeadingTag>
  );
};

export default Title;
